import { logoBase64 } from "../../../../info-technology-process/repair-tools/base64";
import * as docx from "docx";
import { DateHelper } from "../../../../../../helper";
import { Moment } from "moment";

// export const exampleMTPData = [
//   {
//     eTitle: "Tân Sơn Nhất",
//     trainingCourses: [
//       {
//         trainingCourseName: "Khóa đào tạo X",
//         majors: [
//           {
//             majorName: "Nghiệp vụ 1",
//             courses: [
//               {
//                 name: "Môn học X",
//                 trainingType: "Ban đầu",
//                 numsLearnerViags: 123,
//                 numsLearnerVNA: 456,
//                 object: "Đối tượng B",
//                 durationEL: "20 tiết",
//                 durationTT: "35 tiết",
//                 from: "23/12/2023",
//                 to: "25/10/2025",
//                 locationTN: "lầu 7",
//                 locationNN: "lầu 8",
//                 teacher: "Giảng viên 7",
//                 note: "Chú ý học phí",
//               },
//               {
//                 name: "Môn học X",
//                 trainingType: "Ban đầu",
//                 numsLearnerViags: 123,
//                 numsLearnerVNA: 456,
//                 object: "Đối tượng B",
//                 durationEL: "20 tiết",
//                 durationTT: "35 tiết",
//                 from: "23/12/2023",
//                 to: "25/10/2025",
//                 locationTN: "lầu 7",
//                 locationNN: "lầu 8",
//                 teacher: "Giảng viên 7",
//                 note: "Chú ý học phí",
//               },
//             ],
//           },
//           {
//             majorName: "Nghiệp vụ 2",
//             courses: [
//               {
//                 name: "Môn học X",
//                 trainingType: "Ban đầu",
//                 numsLearnerViags: 123,
//                 numsLearnerVNA: 456,
//                 object: "Đối tượng B",
//                 durationEL: "20 tiết",
//                 durationTT: "35 tiết",
//                 from: "23/12/2023",
//                 to: "25/10/2025",
//                 locationTN: "lầu 7",
//                 locationNN: "lầu 8",
//                 teacher: "Giảng viên 7",
//                 note: "Chú ý học phí",
//               },
//               {
//                 name: "Môn học X",
//                 trainingType: "Ban đầu",
//                 numsLearnerViags: 123,
//                 numsLearnerVNA: 456,
//                 object: "Đối tượng B",
//                 durationEL: "20 tiết",
//                 durationTT: "35 tiết",
//                 from: "23/12/2023",
//                 to: "25/10/2025",
//                 locationTN: "lầu 7",
//                 locationNN: "lầu 8",
//                 teacher: "Giảng viên 7",
//                 note: "Chú ý học phí",
//               },
//             ],
//           },
//         ],
//       },
//     ],
//   },
// ];

interface ICourse {
  // name: string; //tên môn học
  // trainingType: string; //loại hình đào tạo
  // numsLearnerViags: number; //Số lượng học viên Vigags
  // numsLearnerVNA: number; //Số lượng học viên VNA
  // object: string; // đối tượng
  // durationEL: string; // thời lượng EL
  // durationTT: string; // thời lượng TT
  // from: string; //từ ngày
  // to: string; // đến ngày
  // locationTN: string; //địa điểm TN
  // locationNN: string; // điểm điểm NN
  // teacher: string; //giáo viên/đối tác
  // note: string; //ghi chú

  eSubject: string;
  eTrainingType: string;
  eTraineeObject: string;
  eDateTime: [Moment, Moment];
  eNotes: string;
  eCourseTrainee: string;
  eTrainees: string;
  eCoursePlaces: string;
  eLessonTypes: string;
}

interface IMajor {
  eTitle: string;
  children: ICourse[];
}

interface TrainingCourse {
  eTitle: string;
  children: IMajor[];
}

interface IItem {
  eTitle: string;
  children: TrainingCourse[];
}

export const getValueWithKeyword = (str: string, keyword: string): string => {
  if (!str) return "";
  const regex = new RegExp(`${keyword}\\((\\d+)\\)`);
  const match = str.match(regex);
  if (match && match[1]) return match[1];
  return "";
};

const getContent = (items: IItem[]) => {
  const result: any[] = [];

  for (let index = 0; index < items.length; index++) {
    const item = items[index];
    result.push(
      new docx.TableRow({
        children: [
          new docx.TableCell({
            children: [
              new docx.Paragraph({
                children: [
                  new docx.TextRun({
                    text: `  ${item.eTitle}`,
                    bold: true,
                    size: 22,
                  }),
                ],
                // alignment: docx.AlignmentType.CENTER,
              }),
            ],
            columnSpan: 12,
          }),

          new docx.TableCell({
            children: [
              new docx.Paragraph({
                children: [
                  new docx.TextRun({
                    text: "",
                    bold: true,
                    size: 22,
                  }),
                ],
              }),
            ],
          }),

          ...[1, 2].map(
            (value, index) =>
              new docx.TableCell({
                children: [],
              })
          ),
        ],
      })
    );
    for (let index1 = 0; index1 < item.children.length; index1++) {
      const trainingCourse = item.children[index1];

      result.push(
        new docx.TableRow({
          children: [
            new docx.TableCell({
              children: [
                new docx.Paragraph({
                  children: [
                    new docx.TextRun({
                      text: `  ${trainingCourse.eTitle}`,
                      // text: `${String.fromCharCode(65 + index)}.${index1 + 1}`,
                      bold: true,
                      size: 22,
                    }),
                  ],
                  // alignment: docx.AlignmentType.CENTER,
                }),
              ],
              columnSpan: 12,
            }),

            new docx.TableCell({
              children: [
                new docx.Paragraph({
                  children: [
                    new docx.TextRun({
                      // text: trainingCourse.eTitle,
                      text: "",
                      bold: true,
                      size: 22,
                    }),
                  ],
                }),
              ],
            }),

            ...[1, 2].map(
              (value, index) =>
                new docx.TableCell({
                  children: [],
                })
            ),
          ],
        })
      );

      for (let index2 = 0; index2 < trainingCourse.children.length; index2++) {
        const major = trainingCourse.children[index2];

        result.push(
          new docx.TableRow({
            children: [
              new docx.TableCell({
                children: [
                  new docx.Paragraph({
                    children: [
                      new docx.TextRun({
                        text: ``,
                        // text: `${StringHelper.intToRoman(index2 + 1)}`,
                        bold: true,
                        size: 22,
                      }),
                    ],
                    alignment: docx.AlignmentType.CENTER,
                  }),
                ],
              }),

              new docx.TableCell({
                children: [
                  new docx.Paragraph({
                    children: [
                      new docx.TextRun({
                        text: major.eTitle,
                        bold: true,
                        size: 22,
                      }),
                    ],
                  }),
                ],
              }),

              ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
                (value, index) =>
                  new docx.TableCell({
                    children: [],
                  })
              ),
            ],
          })
        );

        for (let index3 = 0; index3 < major.children.length; index3++) {
          const course = major.children[index3];

          result.push(
            new docx.TableRow({
              children: [
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: `${index3 + 1}`,
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),

                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: course.eSubject,
                          size: 22,
                        }),
                      ],
                    }),
                  ],
                }),

                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: course.eTrainingType,
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),

                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: getValueWithKeyword(course.eTrainees, "VIAGS"),
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),

                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: getValueWithKeyword(course.eTrainees, "VNA"),
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: course.eTraineeObject,
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: getValueWithKeyword(course.eLessonTypes, "EL"),
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: getValueWithKeyword(course.eLessonTypes, "TT"),
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: DateHelper.formatDateToString(
                            course.eDateTime[0]
                          ),
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: DateHelper.formatDateToString(
                            course.eDateTime[1]
                          ),
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: getValueWithKeyword(course.eCoursePlaces, "TN"),
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: getValueWithKeyword(course.eCoursePlaces, "NN"),
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: course.eCourseTrainee,
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
                new docx.TableCell({
                  children: [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: course.eNotes,
                          size: 22,
                        }),
                      ],
                      alignment: docx.AlignmentType.CENTER,
                    }),
                  ],
                }),
              ],
            })
          );
        }
      }
    }
  }

  return result;
};

export const getDoc = ({
  items,
  textCode,
  issuanceTimes,
  effectiveDate,
}: {
  items: IItem[];
  textCode: string;
  issuanceTimes: string;
  effectiveDate: string;
}) => {
  const imageData = logoBase64;
  const HEADER_TABLE_SIZE = 22;

  return new docx.Document({
    sections: [
      {
        headers: {
          default: new docx.Header({
            children: [
              new docx.Table({
                rows: [
                  new docx.TableRow({
                    children: [
                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new docx.ImageRun({
                                data: imageData,
                                transformation: {
                                  width: 220,
                                  height: 75,
                                },
                              }),
                            ],
                            alignment: docx.AlignmentType.CENTER,
                          }),
                        ],
                        width: { size: 4500, type: docx.WidthType.DXA },
                        verticalAlign: docx.VerticalAlign.CENTER,
                      }),

                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new docx.TextRun({
                                text: "Biểu mẫu",
                                bold: true,
                                size: 24,
                                color: "000000",
                                italics: true,
                              }),
                            ],
                            alignment: docx.AlignmentType.LEFT,
                          }),

                          new docx.Paragraph({
                            children: [
                              new docx.TextRun({
                                text: "KẾ HOẠCH ĐÀO TẠO THÁNG",
                                bold: true,
                                size: 24,
                                color: "000000",
                              }),
                            ],
                            spacing: {
                              before: 200,
                              after: 200,
                            },
                            alignment: docx.AlignmentType.CENTER,
                          }),

                          // new docx.Paragraph({
                          //   children: [
                          //     new docx.TextRun({
                          //       text: "(áp dụng với VNBA/VDAD)",
                          //       bold: false,
                          //       size: 18,
                          //       color: "000000",
                          //     }),
                          //   ],
                          //   spacing: {
                          //     before: 200,
                          //     after: 200,
                          //   },
                          //   alignment: docx.AlignmentType.CENTER,
                          // }),
                        ],
                        width: { size: 5000, type: docx.WidthType.DXA },
                      }),

                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new docx.TextRun({
                                text: `Mã số: ${textCode}`,
                                size: 24,
                              }),
                              new docx.TextRun({
                                text: `Ban hành: ${issuanceTimes}`,
                                size: 24,
                                break: 1,
                              }),
                              new docx.TextRun({
                                text: `Hiệu lực: ${effectiveDate}`,
                                size: 24,
                                break: 1,
                              }),
                              new docx.TextRun({
                                children: ["Trang: ", docx.PageNumber.CURRENT],
                                size: 24,
                                break: 1,
                              }),
                              new docx.TextRun({
                                text: "/",
                                size: 24,
                              }),
                              new docx.TextRun({
                                children: [docx.PageNumber.TOTAL_PAGES],
                                size: 24,
                              }),
                            ],
                          }),
                        ],
                        width: { size: 4500, type: docx.WidthType.DXA },
                        margins: {
                          top: 0,
                          bottom: 100,
                          left: 100,
                          right: 100,
                        },
                        verticalAlign: docx.VerticalAlign.CENTER,
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        },
        properties: {
          page: {
            size: {
              orientation: docx.PageOrientation.LANDSCAPE,
            },
            pageNumbers: {
              start: 1,
              formatType: docx.NumberFormat.DECIMAL,
            },
          },
        },
        children: [
          new docx.Paragraph({
            children: [
              new docx.TextRun({
                break: 1,
              }),
            ],
          }),

          new docx.Table({
            width: {
              size: "100%",
              type: docx.WidthType.PERCENTAGE,
            },
            rows: [
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "STT",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    rowSpan: 2,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Khóa ĐT",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    rowSpan: 2,
                    width: {
                      size: "25%",
                      type: docx.WidthType.PERCENTAGE,
                    },
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Loại hình đào tạo",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    rowSpan: 2,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Số lượng học viên",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    columnSpan: 2,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Đối tượng",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    rowSpan: 2,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Thời lượng",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    columnSpan: 2,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Thời gian",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    columnSpan: 2,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Địa điểm",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    columnSpan: 2,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Giáo viên/ Đối tác",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    rowSpan: 2,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Ghi chú",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                    rowSpan: 2,
                  }),
                ],
              }),

              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Viags",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "VNA",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "EL",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "TT",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Từ ngày",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Đến ngày",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "TN",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "NN",
                            bold: true,
                            size: HEADER_TABLE_SIZE,
                          }),
                        ],
                        alignment: docx.AlignmentType.CENTER,
                      }),
                    ],
                  }),
                ],
              }),
              //main content
              ...getContent(items),
            ],
          }),
          new docx.Paragraph({
            children: [
              new docx.TextRun({
                break: 1,
              }),
            ],
          }),

          new docx.Table({
            width: {
              size: "100%",
              type: docx.WidthType.PERCENTAGE,
            },
            rows: [
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Phòng Tổ chức nhân lực",
                            size: 24,
                            bold: true,
                          }),
                          new docx.TextRun({
                            text: "Họ và tên: ",
                            size: 24,
                            break: 5,
                            bold: true,
                          }),

                          new docx.TextRun({
                            text: "Ngày: ",
                            size: 24,
                            break: 1,
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                    margins: {
                      top: 0,
                      bottom: 100,
                      left: 100,
                      right: 100,
                    },
                    width: {
                      size: "33%",
                      type: docx.WidthType.PERCENTAGE,
                    },
                    verticalAlign: docx.VerticalAlign.CENTER,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Trung tâm đào tạo",
                            size: 24,
                            bold: true,
                          }),
                          new docx.TextRun({
                            text: "Họ và tên: ",
                            size: 24,
                            break: 5,
                            bold: true,
                          }),

                          new docx.TextRun({
                            text: "Ngày: ",
                            size: 24,
                            break: 1,
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                    margins: {
                      top: 0,
                      bottom: 100,
                      left: 100,
                      right: 100,
                    },
                    width: {
                      size: "33%",
                      type: docx.WidthType.PERCENTAGE,
                    },
                    verticalAlign: docx.VerticalAlign.CENTER,
                  }),

                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "Tổng Giám đốc/ Phó Tổng Giám đốc phụ trách đào tạo:",
                            size: 24,
                            bold: true,
                          }),
                          new docx.TextRun({
                            text: "Họ và tên: ",
                            size: 24,
                            break: 4,
                            bold: true,
                          }),

                          new docx.TextRun({
                            text: "Ngày: ",
                            size: 24,
                            break: 1,
                            bold: true,
                          }),
                        ],
                      }),
                    ],
                    margins: {
                      top: 0,
                      bottom: 100,
                      left: 100,
                      right: 100,
                    },
                    width: {
                      size: "33%",
                      type: docx.WidthType.PERCENTAGE,
                    },
                    verticalAlign: docx.VerticalAlign.CENTER,
                  }),
                ],
              }),
            ],
          }),
        ],
      },
    ],
  });
};
